<template>
  <div class="payment-card">
    <template v-for="item in payList">
      <div
        :key="item.pId"
        v-if="
          item.phone === 'all' ||
            item.phone === system ||
            item.phone === browser ||
            (item.phone === 'phone' && system !== '')
        "
      >
        <div
          class="card-payment-item"
          :class="{
            bordermaincolor: payMode === item.pPaymentType && item.pId === pId
          }"
        >
          <div class="card-payment-item-info">
            <img
              v-if="
                item.pPaymentType === 'GOOGLE_PAY' ||
                  item.pPaymentType === 'STRIPE_GOOGLE'
              "
              :src="require('../../../assets/imgs/icon_googlepay.png')"
            />
            <img
              v-else-if="
                item.pPaymentType === 'APPLE_PAY' ||
                  item.pPaymentType === 'STRIPE_APPLE'
              "
              :src="require('../../../assets/imgs/icon_applepay.png')"
            />
            <img
              v-else-if="item.pPaymentType === 'PAYPAL'"
              :src="require('../../../assets/imgs/icon_paypal.png')"
            />
            <img
              v-else
              :src="require('../../../assets/imgs/icon_creditcard.png')"
            />
            <div class="content">
              <div class="title">{{ item.label }}</div>
            </div>
          </div>
          <div v-if="item.paymentConfig" class="card-payment-item-operate">
            <span
              class="card-payment-item-operate-text"
              @click="deletePayCard(item)"
              >{{ i18nConfirm.deletecard }}</span
            >
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { REMOVE_CARD } from "../../../apis/user";

export default {
  props: {
    payList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    pId: {
      type: [String, Number],
      default: () => {
        return "";
      }
    },
    payMode: {
      type: String,
      default: () => {
        return "";
      }
    }
  },
  computed: {
    ...mapState(["system", "user", "qrcode", "browser"]),
    i18nConfirm() {
      return this.$t("confirm");
    },
    i18nMsg() {
      return this.$t("msg");
    }
  },
  methods: {
    // 删除支付卡
    deletePayCard(v) {
      this.$loading(true);
      this.$post(
        `${REMOVE_CARD + v.pId}`,
        {},
        resp => {
          this.$loading(false);
          console.log(resp);
          this.$toast(this.i18nMsg.success);
          this.$emit("onConfirm");
        },
        error => {
          this.$loading(false);
          console.log(error);
          this.$confirm({
            title: this.i18nMsg.title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.confirm,
            showCancel: false
          });
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.card-payment {
  margin: 30px;

  &-label {
    padding: 10px 30px;
    font-size: 36px;
    color: #41200f;
    font-weight: bold;
  }

  &-item {
    display: flex;
    align-items: center;
    padding: 30px 20px;
    border-radius: 20px;
    background: #fff;
    margin-top: 20px;
    border: 1px solid #d5d5d5;

    & img {
      width: 40px;
      height: 40px;
    }

    &-info {
      display: flex;
      align-items: center;
      flex: 1;

      & .content {
        padding-left: 10px;
      }

      & .sub_title {
        font-size: 28px;
        color: #29cdf0;
      }
    }
    &-operate {
      display: flex;
      justify-content: flex-end;
      &-text {
        padding: 4px 12px;
        font-size: 28px;
        color: #fc0d1b;
      }
    }
  }
}
</style>
